const hbp = {
    header: function(selector){
        

        document.addEventListener('scroll', () => {
            //hbp.headerChangeColorTheme();
        });

        //hbp.headerChangeColorTheme();

        try {

        
            document.querySelector('header [megamenu="anchor"]').addEventListener('mouseenter', () => {
                document.querySelector('header').setAttribute('megamenu', 'active');
            });
        
        } catch {}

        try {

            document.querySelector('header .mobile-menu [megamenu="anchor"]').addEventListener('click', () => {
                document.querySelector('header').setAttribute('megamenu', 'active');
            });

        } catch {}

        document.querySelector('header [megamenu="close"]').addEventListener('click', () => {
            document.querySelector('header').setAttribute('megamenu', 'false');
        });
        
        document.querySelector('header').addEventListener('mouseleave', () => {
            document.querySelector('header').setAttribute('megamenu', 'false');
        });
        
        document.querySelectorAll('header .header-link:not([megamenu="anchor"])').forEach(link => {
            link.addEventListener('mouseenter', () => {
                document.querySelector('header').setAttribute('megamenu', 'false');
            });
        }); 

        //

        try {
            document.querySelector('header .mobile-menu [features="anchor"]').addEventListener('click', () => {
                document.querySelector('header').setAttribute('features', 'active');
            });

        } catch {}

        document.querySelector('header [features="close"]').addEventListener('click', () => {
            document.querySelector('header').setAttribute('features', 'false');
        });

        try {
        
            document.querySelector('header [features="anchor"]').addEventListener('mouseenter', () => {
                document.querySelector('header').setAttribute('features', 'active');
            });

        } catch {}

        document.querySelector('header').addEventListener('mouseleave', () => {
            document.querySelector('header').setAttribute('features', 'false');
        });

        document.querySelectorAll('header .header-link:not([features="anchor"])').forEach(link => {
            link.addEventListener('mouseenter', () => {
                document.querySelector('header').setAttribute('features', 'false');
            });
        }); 

        let lastScroll = 0;
        const scrollThreshold = 10; 

        window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;
        const body = document.body;


        if (currentScroll > 0) {
            body.classList.add('sticky-header');
        } else {
            body.classList.remove('sticky-header');
        }


        const delta = currentScroll - lastScroll;


        if (delta > scrollThreshold && currentScroll > 150) {
            body.classList.add('hide-header');
        } 

        else if (delta < -scrollThreshold) {
            body.classList.remove('hide-header');
        }

        lastScroll = currentScroll;
        }); 

        
         
 
    },
    headerChangeColorTheme: function() {
        const header = document.querySelector('header');
        const themedElements = document.querySelectorAll('[color-theme]');
      
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              const colorTheme = entry.target.getAttribute('color-theme');
              header.setAttribute('color-theme', colorTheme); 
            }
          }); 
        }, {
          root: null, 
          threshold: 0.5 
        });
      
        themedElements.forEach(el => observer.observe(el));
    } 
};   
